export default __webpack_public_path__ + "static/media/logo.b704c635.svg";